module.exports = __webpack_public_path__ + "img/carrer.a5b266fb.png";